export default __webpack_public_path__ + "static/CharterITCW05-Regular-bc5e3882d5155d0ddfa327225cd68d35.woff";